// Polyfill for Array.prototype.find (for older iOS Safari)
if (!Array.prototype.find) {
  Array.prototype.find = function (callback) {
    if (this === null || this === undefined) throw new TypeError('Array.prototype.find called on null or undefined');
    if (typeof callback !== 'function') throw new TypeError('callback must be a function');
    const list = Object(this);
    const length = list.length >>> 0;
    const thisArg = arguments[1];
    for (let i = 0; i < length; i++) {
      const value = list[i];
      if (callback.call(thisArg, value, i, list)) return value;
    }
    return undefined;
  };
}

// Ensure product data is fully loaded before initializing
function waitForProductData(callback) {
  if (window.json_product && window.variant_lead_times) {
    console.log('Product data loaded successfully:', window.json_product, window.variant_lead_times);
    callback();
  } else {
    console.log('Waiting for product data...');
    setTimeout(() => waitForProductData(callback), 100);
  }
}

// Function to update lead time element
function updateLeadTimeElement(variant) {
  const leadTimeElement = document.getElementById('lead-time');
  const leadTimeWrap = document.querySelector('.lead-time-wrap');

  if (!leadTimeElement || !leadTimeWrap) {
    console.warn('Lead time element or wrapper not found. Retrying...');
    setTimeout(() => updateLeadTimeElement(variant), 100);
    return;
  }

  console.log('Updating lead time for variant:', variant);

  // Check if a specific lead time exists for this variant
  const variantLeadTime = window.variant_lead_times.find(item => item.id === variant.id)?.lead_time;

  if (variantLeadTime) {
    // Apply variant-specific lead time
    leadTimeElement.textContent = variantLeadTime;
    leadTimeWrap.className = 'lead-time-wrap lead-time-color';
    console.log('Lead time updated to variant-specific value:', variantLeadTime);
  } else {
    // Fallback to product-level lead time or availability
    if (window.product_lead_time) {
      // Apply product-level lead time
      leadTimeElement.textContent = window.product_lead_time;
      leadTimeWrap.className = 'lead-time-wrap lead-time-color';
      console.log('Lead time updated to product default value:', window.product_lead_time);
    } else if (variant.available) {
      // No lead time exists, and the variant is available
      leadTimeElement.textContent = 'In stock';
      leadTimeWrap.className = 'lead-time-wrap in-stock-lead';
      console.log('Lead time set to "In stock" for available variant.');
    } else {
      // No lead time exists, and the variant is unavailable
      leadTimeElement.textContent = 'Out of stock';
      leadTimeWrap.className = 'lead-time-wrap out-stock';
      console.log('Lead time set to "Out of stock" for unavailable variant.');
    }
  }

  // Confirm class update in console
  console.log('Updated lead-time-wrap class to:', leadTimeWrap.className);
}

// Function to get the current variant ID
function getCurrentVariantId(eventTarget) {
  console.log('Fetching current variant ID...');

  // Attempt to get the variant ID from the selected input
  const currentVariantInput = document.querySelector('[name="id"]:checked');
  if (currentVariantInput) {
    console.log('Current variant ID found from input:', currentVariantInput.value);
    return currentVariantInput.value;
  }

  // Attempt to get the variant ID from the clicked element
  if (eventTarget && eventTarget.dataset && eventTarget.dataset.variantId) {
    console.log('Current variant ID found from clicked element:', eventTarget.dataset.variantId);
    return eventTarget.dataset.variantId;
  }

  // Fallback to the URL parameter
  const urlVariantId = new URLSearchParams(window.location.search).get('variant');
  if (urlVariantId) {
    console.log('Current variant ID found from URL:', urlVariantId);
    return urlVariantId;
  }

  console.warn('No variant ID found in input, URL, or clicked element.');
  return null;
}

// Main logic for handling variant changes
function initializeVariantLogic() {
  function updateOnVariantChange(event) {
    console.log('Variant change detected. Waiting for DOM update...');

    // Delay to ensure DOM updates for variant selection are complete
    setTimeout(() => {
      const variantIdToUse = getCurrentVariantId(event?.target);

      if (variantIdToUse) {
        const variant = window.json_product.variants.find(v => v.id === parseInt(variantIdToUse, 10));
        if (variant) {
          console.log('Variant found:', variant);

          // Debugging: Log if a lead time exists
          const variantLeadTime = window.variant_lead_times.find(item => item.id === variant.id)?.lead_time;
          console.log(
            variantLeadTime
              ? `Lead time metafield found: ${variantLeadTime}`
              : `No lead time metafield found for variant: ${variant.id}`
          );

          updateLeadTimeElement(variant);
        } else {
          console.error('No matching variant found for ID:', variantIdToUse);
        }
      } else {
        console.error('No variant ID available after variant change.');
      }
    }, event?.target ? 500 : 700); // Slightly longer delay for initial interactions
  }

  console.log('Initializing variant logic...');

  // Use MutationObserver to ensure DOM readiness for variant data
  const variantObserver = new MutationObserver(() => {
    const variantInput = document.querySelector('[name="id"]:checked');
    if (variantInput) {
      console.log('DOM updated. Variant input detected:', variantInput.value);
      updateOnVariantChange();
    }
  });

  variantObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  updateOnVariantChange(); // Run on page load

  // Add click event listeners for variant options
  document.querySelectorAll('[data-js-option-value]').forEach(option => {
    option.addEventListener('click', (event) => {
      console.log('Variant option clicked:', event.target);
      updateOnVariantChange(event);
    });
  });

  // Add listener for hash changes (useful if variant changes via URL updates)
  window.addEventListener('popstate', () => {
    console.log('Popstate event detected. Updating lead time...');
    updateOnVariantChange();
  });

  // Add change event listener for select inputs (if present)
  document.querySelectorAll('select[name="id"]').forEach(select => {
    select.addEventListener('change', (event) => {
      console.log('Variant select changed. Updating lead time...');
      updateOnVariantChange(event);
    });
  });
}

// Initialize script
document.addEventListener('DOMContentLoaded', () => {
  console.log('Document ready. Initializing script...');
  waitForProductData(() => initializeVariantLogic());
});
